import * as ko from "knockout";
import {REQUEST_THROTTLE_QUICK, SPINNER} from "../../constants";
import {storeObservable} from "../../util/sessionstore";
import {nsLanguage} from "../../util/nsLanguage";
import {getAnyValue} from "../../util/misc";
import {TBaseOrObservableOrFunctionType} from "../../index";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {lm} from "../../appContext";
import navigationHtml from './navigation.html?raw';

export const template = navigationHtml;

export interface IParams {
    data?: KnockoutObservableArray<any>
    resultsprpage?: KnockoutObservable<number>
    onSubmit?: () => {}
    pagenr: KnockoutObservable<number>
    pages?: KnockoutObservable<number>
    totalresults?: KnockoutObservable<number>
    maxpagenr?: TBaseOrObservableOrFunctionType<number>
}

export class viewModel {
    private resultsprpage: KnockoutObservable<any>;
    private maxpagenr: TBaseOrObservableOrFunctionType<number>;
    private inputPagenr: KnockoutObservable<string | number | null> = ko.observable(null).extend({throttle: REQUEST_THROTTLE_QUICK})
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker()

    constructor(protected params: IParams) {
        this.resultsprpage = params.resultsprpage || storeObservable("num.search.results");
        this.maxpagenr = params.maxpagenr || Infinity
        this.inputPagenr(params.pagenr() + 1)
        this.kosub.subscribeChanged(this.inputPagenr as KnockoutObservable<string | number>, (val: string | number) => this.onInputPagenr(val))
        this.kosub.subscribe(this.params.pagenr, (num: number) => this.inputPagenr(num + 1))
    }

    private onInputPagenr(val: string | number) {
        const num = Number(val)
        if (isNaN(num) || num < 1 || num > this.getNumPages()) {
            return
        }
        this.params.pagenr(num - 1)
    }

    private onInputFocusOut() {
        const num = Number(this.inputPagenr())
        if (isNaN(num) || num < 1 || num > this.getNumPages()) {
            this.inputPagenr(this.params.pagenr() + 1)
        }
    }

    private isPreviousPageEnabled = ko.pureComputed((): boolean => {
        return this.params.pagenr() > 0;
    });

    private isNextPageEnabled = ko.pureComputed((): boolean => {
        return this.params.pagenr() + 1 < this.getNumPages();
    });

    private getTotalResults(): number {
        return this.params.totalresults?.() ?? getAnyValue(this.params.data ?? ko.observableArray([]))?.length ?? 0
    }

    private onPreviousPageClick() {
        this.params.pagenr(this.params.pagenr() - 1);
        this.params.onSubmit?.();
    }

    private onNextPageClick() {
        const pagenr = Math.min(this.params.pagenr() + 1, getAnyValue(this.maxpagenr));
        this.params.pagenr(pagenr);
        this.params.onSubmit?.();
    }

    private onFirstPageClick() {
        this.params.pagenr(0);
        this.params.onSubmit?.();
    }

    private onLastPageClick() {
        const pagenr = Math.min(Math.ceil(this.getTotalResults() / this.resultsprpage()) - 1, getAnyValue(this.maxpagenr));
        this.params.pagenr(pagenr);
        this.params.onSubmit?.();
    }

    private getNumPages = ko.pureComputed(() => {
        const pages = this.params.pages?.();
        const calc = Math.ceil(this.getTotalResults() / this.resultsprpage());
        return pages ?? calc ?? null
    });

    private getPagingText = ko.pureComputed(() => {
        let spinner = SPINNER;
        storeObservable('language')()
        let current = nsLanguage.toLocaleString(this.params.pagenr() + 1);
        let total = this.getNumPages() === null ? spinner : nsLanguage.toLocaleString(this.getNumPages());
        const ret = `page x of y|x:INPUT|y:${total}`
        return (lm.t(ret) ?? '').split(' INPUT ')
    });

    dispose() {
        this.kosub.unsuscribeAll()
    }

}
